var render = function () {
  var _vm$stepLeft$answerIm, _vm$stepLeft$answerIm2, _vm$stepLeft$monochro, _vm$stepLeft$monochro2, _vm$stepRight$answerI, _vm$stepRight$answerI2, _vm$stepRight$monochr, _vm$stepRight$monochr2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    staticClass: "one-and-more",
    attrs: {
      "slot": "content",
      "s": ""
    },
    slot: "content"
  }, [_vm.currentRound.steps ? _c('div', {
    staticClass: "steps-container"
  }, [_c('div', {
    staticClass: "step left-side"
  }, [_c('img', {
    attrs: {
      "alt": "Left side image",
      "src": _vm.stepLeftIsFinished ? (_vm$stepLeft$answerIm = _vm.stepLeft.answerImage) === null || _vm$stepLeft$answerIm === void 0 ? void 0 : (_vm$stepLeft$answerIm2 = _vm$stepLeft$answerIm.image) === null || _vm$stepLeft$answerIm2 === void 0 ? void 0 : _vm$stepLeft$answerIm2.src : (_vm$stepLeft$monochro = _vm.stepLeft.monochromeImage) === null || _vm$stepLeft$monochro === void 0 ? void 0 : (_vm$stepLeft$monochro2 = _vm$stepLeft$monochro.image) === null || _vm$stepLeft$monochro2 === void 0 ? void 0 : _vm$stepLeft$monochro2.src
    }
  }), _c('text-display-list', {
    staticClass: "left-side type-line",
    attrs: {
      "text-size": "small"
    }
  }, [_c('li', [_c('blinking-cursor-text', {
    attrs: {
      "text": _vm.stepLeft.answer,
      "text-step": 0,
      "roundId": _vm.progress.roundIndex
    }
  })], 1)])], 1), _c('div', {
    staticClass: "step right-side",
    style: {
      visibility: _vm.rightSideIsVisible ? 'visible' : 'hidden'
    }
  }, [_c('img', {
    attrs: {
      "alt": "Right side image",
      "src": _vm.stepRightIsFinished ? (_vm$stepRight$answerI = _vm.stepRight.answerImage) === null || _vm$stepRight$answerI === void 0 ? void 0 : (_vm$stepRight$answerI2 = _vm$stepRight$answerI.image) === null || _vm$stepRight$answerI2 === void 0 ? void 0 : _vm$stepRight$answerI2.src : (_vm$stepRight$monochr = _vm.stepRight.monochromeImage) === null || _vm$stepRight$monochr === void 0 ? void 0 : (_vm$stepRight$monochr2 = _vm$stepRight$monochr.image) === null || _vm$stepRight$monochr2 === void 0 ? void 0 : _vm$stepRight$monochr2.src
    }
  }), _c('text-display-list', {
    staticClass: "right-side type-line",
    attrs: {
      "text-size": "small"
    }
  }, [_c('li', [_c('blinking-cursor-text', {
    attrs: {
      "text": _vm.stepRight.answer,
      "text-step": 1,
      "roundId": _vm.progress.roundIndex
    }
  })], 1)])], 1)]) : _vm._e()])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }